export const TWO_FACTOR_DIALOG_OPTIONS = {
  width: '600px',
  maxWidth: '95vw',
  disableClose: true,
  panelClass: 'no-radius-dialog',
};

export const CODE_LENGTH = 6;

export const CODE_REGEX = /^\d$/;
